import { RecurringProfileActions } from '../actions/actionTypes'
import { RecurringProfileInterface } from '../Interfaces/RecurringProfileInterface'
import { Immutable } from '../Other/Immutable'
import { ReducerBuilder } from './ReducerBuilder'

type StateType = RecurringProfileInterface[] | {}
type PayloadType = RecurringProfileInterface[] | RecurringProfileInterface

const INITIAL_STATE = {}

function updateRecurringProfile(state: RecurringProfileInterface[], payload: RecurringProfileInterface) {
  const newState = Immutable.copy(state)
  if (Array.isArray(newState)) {
    newState[newState.findIndex((profile) => profile.id === payload.id)] = payload
  }
  return newState
}

const reducer = ReducerBuilder.create<StateType, PayloadType>(INITIAL_STATE)
  .mapAction(
    RecurringProfileActions.GET_RECURRING_PROFILES,
    (state: StateType, payload: RecurringProfileInterface[]) => payload,
  )
  .mapAction(RecurringProfileActions.UPDATE_RECURRING_PROFILE, updateRecurringProfile)
  .build()

export default reducer
